export class AddOrUpdateWebScraperPortalPopupManager {

    constructor(private containerElement: JQuery) { }

    private passwordInput : JQuery<HTMLElement>;
    private togglePasswordButton : JQuery<HTMLElement>;

    private portalTemplateSelect : JQuery<HTMLElement>;
    private portalPropertiesContainer : JQuery<HTMLElement>;

    private usernamePasswordContainer : JQuery<HTMLElement>;
    private fromEmailLinkContainer : JQuery<HTMLElement>;


    public initialize() {
        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        self.passwordInput = self.containerElement.find('#passwordInput');
        self.togglePasswordButton = self.containerElement.find('#togglePassword');

        self.portalTemplateSelect = self.containerElement.find('#portal-template-list');
        self.portalPropertiesContainer = self.containerElement.find('#web-scraper-additional-properties-container');

        self.usernamePasswordContainer = self.containerElement.find('#access-type-username-password-container');
        self.fromEmailLinkContainer = self.containerElement.find('#access-type-from-email-link-container');

        //this.linesTable = this.containerElement.find('#lines-table');
    }

    private bindEvents() {
        var self = this;

        self.togglePasswordButton.off('click').on('click', function () {
            const $icon = $(this).find('i');

            const show = self.passwordInput.attr('type') === 'password';
            self.passwordInput.attr('type', show ? 'text' : 'password');

            $icon.toggleClass('fa-eye', !show);
            $icon.toggleClass('fa-eye-slash', show);
        });

        self.passwordInput.off('change').on('change', () => {
            self.containerElement.find('#PasswordChanged').val('True');
        })

        self.portalTemplateSelect.off('change').on('change', () => {
            var portalName : any = self.portalTemplateSelect.val();
            portalName = encodeURI(portalName);

            self.portalPropertiesContainer.load(`?portalName=${portalName}&handler=PortalProperties`)
        });


        var accessModeSwitchInputs = self.containerElement.find('#access-mode-container input');
        accessModeSwitchInputs.each((index, element) => {
            var accessModeInput = $(element);
            accessModeInput.off('click').on('click', () => {
                var selectedAccessMode : any = accessModeInput.val()?.toString();   
                console.log(selectedAccessMode);

                self.usernamePasswordContainer.addClass("d-none");
                self.fromEmailLinkContainer.addClass("d-none");

                if(selectedAccessMode == "UsernamePassword") {
                    self.usernamePasswordContainer.removeClass("d-none");
                }
                else if(selectedAccessMode == "FromEmailLink") {
                    self.fromEmailLinkContainer.removeClass("d-none");
                }
            }); 
        })
    }
}